/** Escape text before injecting into HTML. */
export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/** Wrap selected `@Name` tokens for orange theme styling. */
export function highlightMentions(text: string, mentionNames: string[]): string {
  if (!text) return '';

  let result = escapeHtml(text);
  const names = [...new Set(mentionNames.filter(Boolean))].sort(
    (a, b) => b.length - a.length
  );

  for (const name of names) {
    const escapedName = escapeHtml(name);
    const pattern = new RegExp(
      `(@${escapeRegExp(escapedName)})(?=\\s|$|[.,!?;:])`,
      'g'
    );
    result = result.replace(pattern, '<span class="chat-mention">$1</span>');
  }

  return result;
}
